import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { RsCmsServicesModule } from '@digital-platform/rs-cms/services';
import { NavComponent } from '@digital-platform/rs-cms/ui';
import { AccountDropdownButtonComponent } from '@digital-platform/rs-header/ui';
import { AlertBannerComponent } from './alert-banner/alert-banner.component';
import { HeaderComponent } from './header/header.component';

@NgModule({
  imports: [
    AccountDropdownButtonComponent,
    AlertBannerComponent,
    NavComponent,
    CommonModule,
    FormsModule,
    RsCmsServicesModule,
    RouterModule.forChild([
      {
        path: '',
        component: HeaderComponent,
      },
    ]),
  ],
  declarations: [HeaderComponent],
  providers: [TranslateService],
})
export class RsHeaderFeatureHeaderModule {}
